module.exports = __webpack_public_path__ + "img/fig36.ce7ae33e.jpg";